import { useMemo, useState, useEffect } from "react";
import Accordion from 'react-bootstrap/Accordion';
import {SetMetaData} from './../../helper/page-title';
import ValidationHelper from "../../helper/validation";
import useInfiniteList from "../../hooks/infinite-list";
import useRowSelection from "../../hooks/row-selection";
import useColumnSettings from "../../hooks/column-setting";
import InfiniteListWrapper from "../../components/wrapper/infinite-list";
import { error_api_call, post_api_call, get_api_call } from "../../actions/action-creators/common";
import { alertResponseMessage } from "../../actions/action-creators/response";
import { masterTableFields, fieldValuesYear, fieldUpdateYear, fieldValidationYear } from "../../data/formData/glosco/level";
import FilterInput from "../../components/form/filter/filter-input";
import {SettingDropdownUi, TableCheckboxUi, RowDataUi} from "../../components/form/master-table/ui-static";
import MasterForm  from '../../components/form/master';
import normalizeFilters from "../../helper/filter/normalize-filter";
import {
  portExpiryOpp
} from "../../data/formData/option";

function ManageLevel(props) {
    SetMetaData("Manage GLOSCO Year/Level", "", "");
    const [filterData, setFilterData] = useState({});
    const [errorData, setErrorData] = useState({update_year: []});
    const [formYearData, setYearFormData] = useState({...fieldValuesYear});
    const [isProcess, setIsProcess] = useState({update_year: false});
    const [refreshKey, setRefreshKey] = useState(0);

    const { columnSettings, updateColumn } = useColumnSettings({
        user_id: true,
        glosco_level_id: true,
        validity_id: true,
        name: true,
        school_id: true,
        branch_id: true,
        class_id: true,
        email: true
    });

    const [optionData, setOptionData] = useState({
        glosco_level_id: [],
        validity_id: portExpiryOpp,
        school_id: [],
        branch_id: [],
        class_id: []
    });

    // const memoizedFilterData = useMemo(
    //     () => filterData,
    //     [JSON.stringify(filterData)]
    // );
    const normalizedFilter = useMemo(
    () =>
        normalizeFilters(filterData, {
            school_id: "id",
            validity_id: "id",
            class_id: "id",
            branch_id: "id"
        }),
        [filterData]
    );


    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading
    } = useInfiniteList({
        queryKey: ["glosco_year", refreshKey],
        apiCall: payload => post_api_call("glosco-year", payload),
                limit: 100,
                extraPayload: {
                    fetch_type: "glosco_year",
                    filter: normalizedFilter
                }
    });

    // const masterTableData = data?.pages.flatMap(page => page.data) ?? [];
    const masterTableData = Array.isArray(data?.pages)
                            ? data.pages.flatMap(page => Array.isArray(page?.data) ? page.data : [])
                            : [];
    // const visibleUserIds = masterTableData.map(r => r.user_id);

    const {
        // selectedIds,
        isChecked,
        isAllSelected,
        isIndeterminate,
        toggleRow,
        selectAllVisible,
        clearAllVisible
    } = useRowSelection({
        data: masterTableData,
        rowKey: "user_id",
        // value: formYearData.user_ids_array || [],   // ✅ VERY IMPORTANT
        value: (formYearData.user_ids_array || []).map(String),
        maxSelection: 300,
        onLimitExceed: limit => {
            alertResponseMessage({
                alert_type: 3,
                message: `You can select maximum ${limit} users at once.`
            });
        },
        onChange: ids => {
            setYearFormData(prev => ({
                ...prev,
                user_ids_array: ids,
                user_ids: ids.join(",")
            }));
        }
    });
    //Get Data from APIs
    const fetchSelectList = async(type, url) => {
      try{
          const selectApiData = await get_api_call(url, {});
          var data = [];
          if(selectApiData.status === 200){
              data = selectApiData.data;
              switch (type) {
                  case 'manage_glosco_year':
                    setOptionData({...optionData,
                        glosco_level_id: data?.glosco_years,
                        school_id: data?.schools,
                        branch_id: data?.branches,
                        class_id: data?.classes
                    });
                    break;
                  default: 
              }
          }
          return {
              data
          };
      }catch(e){
        error_api_call({error: `admin|glosco|manage-level|fetchSelectList|${e}`});
        return {data: []};
      }
    }

    useEffect(() => {
        fetchSelectList('manage_glosco_year', 'dropdown-options/manage-glosco-year');
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    const updateInput = (form_type, attrName, value) => {
        try {
            if(form_type === "update_year") {
                if(errorData[form_type].length){
                    setErrorData({...errorData, [form_type]: []});
                }
                
                if (attrName === "user_ids") {
                    value = value
                        .replace(/[^0-9,]/g, "")   // allow digits & comma
                        .replace(/,{2,}/g, ",");   // prevent multiple commas

                    const ids = value
                        .split(",")
                        .map(v => v.trim())
                        .filter(Boolean)
                        .map(String);     // ✅ normalize

                    const uniqueIds = Array.from(new Set(ids));

                    setYearFormData(prev => ({
                        ...prev,
                        user_ids: value,           // raw text
                        user_ids_array: uniqueIds     // normalized
                    }));
                }else{
                    let fields = {...formYearData};
                    fields[attrName] = value;
                    setYearFormData({...fields});
                }
            }else if(form_type === "filter"){
                let fields = {...filterData};
                fields[attrName] = value;
                setFilterData({...fields});
            }
        } catch (e) {
            console.log(e);
            error_api_call({
                error: `glosco/manage-level|updateInput|${e}`
            });
        }
    };
    //Submit Details
    const submitForm = async(e, form_type='') => {
        try{
            e.preventDefault();
            setErrorData({...errorData, [form_type]: []});
            setIsProcess({...isProcess, [form_type]: true});
            var errorDetails = [];
            var apiFormData = new FormData();
            //Validation
            var validation = [];
            var inputData = {};
            var validationFields = {};
            switch (form_type) {
                case 'update_year':
                    inputData = {...formYearData};
                    validationFields = fieldValidationYear;
                    break;
                default:
            }
            validation = ValidationHelper.validation(inputData, validationFields).error;
            if(validation.length){
                errorDetails = validation;
            }
          
            if(errorDetails.length > 0){
                setErrorData({...errorData, [form_type]: errorDetails});
                setIsProcess({...isProcess, [form_type]: false});
                // setBtnDisabled({...isBtnDisabled, [form_type]: true});
            }else{
                //Send Data to Server
                var api = '';
                switch (form_type) {
                    case 'update_year':
                        api = 'glosco/update/level-year';
                        apiFormData.append('year_id', inputData.year_id.id);

                        const uniqueIds = [...new Set(inputData.user_ids_array)];
                        uniqueIds.forEach(id => {
                            if (id !== "" && id !== null) {
                                apiFormData.append("user_ids[]", Number(id));
                            }
                        });
                        break;
                    default:
                }

                const updateOppor = await post_api_call(`${api}`, apiFormData);
                if(updateOppor.status === 200){
                    alertResponseMessage({alert_type: 1, message: "Information Updated Successfully"});
                    // setBtnDisabled({...isBtnDisabled, [form_type]: true});
                    clearAllVisible();
                    // setYearFormData({...formYearData, user_ids: '', user_ids_array: []});
                    setRefreshKey(prev => prev + 1); // 🔥 RESET TABLE
                }else{
                    if(typeof updateOppor.message !== "undefined"){
                        setErrorData({...errorData, [form_type]: [updateOppor.message]});
                    }
                }
                setIsProcess({...isProcess, [form_type]: false});
            }
          
        }catch(error){
            console.error(error);
            setErrorData({...errorData, [form_type]: ['Something Went Wrong, Please Try After Some Time']});
            setIsProcess({...isProcess, [form_type]: false});
            error_api_call({error: `admin|screens|glosco|manage-level|${error}`});
        }
    }

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card p-2 mb-2 mod-custom z-index-99999">
                    <Accordion
                        className="filter-custom"
                    >
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>
                                Update GLOSCO Year/Level 
                            </Accordion.Header>
                            <Accordion.Body className="p-2">
                                <MasterForm
                                    formType={'update_year'}
                                    data={formYearData}
                                    _errorData={{...errorData}}
                                    _isProcess={{...isProcess}}
                                    // _isBtnDisabled={{...isBtnDisabled}}
                                    _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(form_type, field, value)}
                                    _submitForm={(e, form_type) => submitForm(e, form_type)}
                                    _formData={[{form_type: 'update_year', label: "Year/Level", fields: [...fieldUpdateYear]}]}
                                    selectOptions={{year_id:
                                                    {value: 'id',
                                                    label: 'label',
                                                    data: [...optionData.glosco_level_id],
                                                    }
                                                }}
                                />
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </div>

            <InfiniteListWrapper
                dataLength={masterTableData.length}
                isLoading={isLoading}
                hasNextPage={hasNextPage}
                fetchNextPage={fetchNextPage}
                isFetchingNextPage={isFetchingNextPage}
                emptyMessage="No Record found!"
            >
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        {/* SETTINGS */}
                        <SettingDropdownUi
                            checkedData={columnSettings}
                            fields={masterTableFields}
                            updateColumn= {(field, value) => updateColumn(field, value)}
                        />

                        {/* TABLE */}
                        <div className="card-body table-responsive sticky-table pt-0 pe-0 ps-3">
                            <table className="table">
                                <thead>
                                <tr>
                                    <th>
                                        <TableCheckboxUi
                                            id="select_row"
                                            name="select_row"
                                            checked={isAllSelected}
                                            ref={el => el && (el.indeterminate = isIndeterminate)}
                                            // onChange={(e) =>
                                            //     e.target.checked ? selectAllVisible() : clearAllVisible()
                                            // }
                                            onChange={(e) => e.target.checked
                                                            ? selectAllVisible()
                                                            : clearAllVisible()}
                                        />
                                    </th>

                                    {masterTableFields.map((col, i) => (
                                    (typeof col.accessRoleIds === "undefined" ||
                                        props.userRoleIds.some(role =>
                                        col.accessRoleIds.includes(role)
                                        )) &&
                                        columnSettings[col.field.name] && (
                                            <th key={i} className={`w-200p ${col.class_name || ""}`}>
                                            {col.title}
                                            {col.is_searchable && (
                                                <FilterInput
                                                    formType="filter"
                                                    field={col?.field}
                                                    data={filterData}
                                                    selectOptions={
                                                        (col.field?.type === "multi-select"
                                                        || col.field?.type === "select")
                                                        ?
                                                            {[col.field?.name]: {
                                                                value: col?.option_val,
                                                                label: col?.option_label,
                                                                data: optionData[col.field?.name]
                                                            }}
                                                        :
                                                            {}
                                                        }
                                                    _updateInput= {(form_type, data_type, input_type, field, value) => updateInput(form_type, field, value)}
                                                />
                                            )}
                                            </th>
                                        )
                                    ))}
                                    <th>Action</th>
                                </tr>
                                </thead>

                                <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan="20" className="text-center p-4">
                                            <img
                                                alt="Loader"
                                                src={require("../../assets/images/Image-Loader.gif")}
                                            />
                                        </td>
                                    </tr>
                                ) : (
                                    masterTableData.length > 0 
                                    ? (
                                        masterTableData.map((row, index) => {
                                        return (
                                            <tr
                                                key={index}
                                                className={isChecked(row.user_id) ? "table-success" : ""}
                                                onClick={() => toggleRow(row.user_id)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <td onClick={e => e.stopPropagation()}>
                                                    <TableCheckboxUi
                                                        id={row.user_id}
                                                        name="select_row"
                                                        checked={isChecked(row.user_id)}
                                                        onChange={() => toggleRow(row.user_id)}
                                                    />
                                                </td>

                                                {masterTableFields.map((tbl, i) => (
                                                    (typeof tbl.accessRoleIds === "undefined" ||
                                                    props.userRoleIds.some(role =>
                                                        tbl.accessRoleIds.includes(role)
                                                    )) &&
                                                    columnSettings[tbl.field.name] && (
                                                    <td key={i}>
                                                        {/* {row[tbl.fetch_key]} */}
                                                        <RowDataUi
                                                            fetch_key={tbl.fetch_key}
                                                            data={row}
                                                            data_type={tbl?.data_type}
                                                        />
                                                    </td>
                                                    )
                                                ))}

                                                <td onClick={e => e.stopPropagation()}>
                                                    <a href={`/student/${row.url}`} target="_blank" rel="noreferrer"><button className="btn btn-sm btn-behance" title="View Portfolio"><i className="mdi mdi-eye"></i></button></a>
                                                </td>
                                            </tr>
                                        );
                                        })
                                    )
                                    : 
                                    <tr>
                                        {/* <td colSpan={props.userRoleIds.includes(2) ? 13 : 11}> */}
                                        <td colSpan="20">
                                        <div className="no-fellow text-center mt-4">
                                            {/* {emptyImage && <img src={emptyImage} alt="No Data" />} */}
                                            <p className="pt-4 head">{"No Record Found!"}</p>
                                        </div>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </InfiniteListWrapper>
        </div>
    );
}

export default ManageLevel;